import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../brand/Logo';

export default function SiteFooter() {
  return (
    <footer className="home-foot">
      <div className="home-foot-grid">
        <div>
          <Logo wordmark className="mb-3" />
          <p>Clarifier votre business.</p>
        </div>
        <nav>
          <Link to="/studio">Studio</Link>
          <Link to="/pricing">Tarifs</Link>
          <Link to="/blog">Journal</Link>
          <Link to="/about">À propos</Link>
          <a href="/llms.txt">llms.txt</a>
          <a href="/llm.txt">llm.txt</a>
        </nav>
        <nav>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Confidentialité</Link>
          <Link to="/terms">CGU</Link>
          <Link to="/legal">Mentions</Link>
        </nav>
      </div>
      <p className="home-foot-copy">
        © {new Date().getFullYear()} Clairify · STELLARMEET SAS · Paris
      </p>
    </footer>
  );
}
